import { z } from 'zod';
import { ResourceLibraryAssetItem } from '../types/resourceLibraryItems';
import { GetResourceLibraryAssetItemListingSchema } from '../schemas/resourceLibraryAssetItemZodSchemas';
import { LocaleCode } from '../../../../../utils/Locale';
import { hydrateResourceLibraryAssetItem } from './transformResourceLibraryAssetItemResponse';

/**
 * Transforms and validates the response from the getResourceLibraryAssetItemListing GraphQL query
 * to a simplified ResourceLibraryAssetItem[] type.
 *
 * @param data The response data from the getResourceLibraryItemListing query
 * @returns An array of valid ResourceLibraryAssetItem objects
 */
export function transformResourceLibraryAssetItemsResponse(
    data: unknown, // GetResourceLibraryAssetItemListingQuery - use unknown for jest tests be able to
    // pass invalid data
    localeCode: LocaleCode
): ResourceLibraryAssetItem[] {
    // Parse and validate the data using the Zod schema
    const parsedResult = GetResourceLibraryAssetItemListingSchema.safeParse(data);

    if (!parsedResult.success) {
        console.error(
            'Validation failed for getResourceLibraryItemListing:',
            parsedResult.error.errors
        );
        return [];
    }

    const resourceItemListingEdges = parsedResult.data.getResourceLibraryItemListing.edges;

    // Transform resource items to simplified ResourceLibraryItem type
    return resourceItemListingEdges.map(({ node }) => {
        const item = node as z.infer<
            typeof GetResourceLibraryAssetItemListingSchema
        >['getResourceLibraryItemListing']['edges'][number]['node'];

        return hydrateResourceLibraryAssetItem(item, localeCode);
    });
}
